module.exports = __webpack_public_path__ + "static/media/Ellipse 82.d377eda5.svg";